class CacheManager {
    private cache = new Map<
        string,
        { value: unknown; dependenciesHash: string }
    >();

    get<T>(key: string, dependencies: unknown[], factory: () => T): T {
        const dependenciesHash = JSON.stringify(dependencies);
        const cachedEntry = this.cache.get(key);

        if (cachedEntry && cachedEntry.dependenciesHash === dependenciesHash) {
            return cachedEntry.value as T;
        }

        const newValue = factory();
        this.cache.set(key, { value: newValue, dependenciesHash });

        return newValue;
    }

    set<T>(key: string, value: T, dependencies: unknown[]) {
        const dependenciesHash = JSON.stringify(dependencies);
        this.cache.set(key, { value, dependenciesHash });
    }

    clear(key?: string) {
        if (key) {
            this.cache.delete(key);
        } else {
            this.cache.clear();
        }
    }
}

export default CacheManager;
